<template>
  <div class="answer-box">
    <header class="header-box">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="10" />
        <span>返回</span>
      </div>
    </header>

    <div class="answer-content">
      <div class="answer-right">
        <div class="sub-header">
          <img src="~images/exam/line.png" width="5" />
          <span class="text">请设置试卷答案</span>
        </div>

        <div class="allScore">
          <label>从</label>
          <el-input class="numFrom" v-model="setFrom" placeholder=""></el-input>
          <label>到</label>
          <el-input class="numTo" v-model="setTo" placeholder=""></el-input>
          <label>题</label>
          <el-input class="numFrom" v-model="setScore" placeholder=""></el-input>
          <label style="margin: 0 10px 0 5px">分/题</label>
          <div class="type-select">
            <el-select v-model="isMul" placeholder="--" size="mini">
              <el-option v-for="item in choiceTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <span v-show="isMul == 0">请填写选不全答案的得分/题</span>
          <el-input v-show="isMul == 0" class="numTo" v-model="halfPoint" placeholder=""></el-input>
          <el-button type="primary" size="mini" @click="totalOn" class="numOk">确认</el-button>
        </div>
        <div class="content-area" style="margin-top: 0px;">
          <el-table :data="answerList" border v-loading="loading" size="mini" height="440" style="width: 100%">
            <el-table-column prop="num" align="center" label="序号">
            </el-table-column>
            <el-table-column label="大题号" prop="bigNum" align="center">
            </el-table-column>
            <el-table-column label="小题号" prop="smallNum" align="center">
            </el-table-column>
            <el-table-column align="center" label="答案">
              <template slot-scope="scope">
                <div class="input-font" v-if="isRegion">
                  {{ scope.row.answer }}
                </div>
                <div v-else>
                  <div class="answer answer-font" v-if="scope.row.choiceTypeCode == 1 || scope.row.choiceTypeCode == 0">
                    <input type="text" :style="scope.row.answer == '' ? 'border: 1px solid #f88e05' : ''"
                      :class="scope.row.answer == '' && answerSubmitCount > 0 ? 'inputWraning' : ''" @keydown="wantEdit"
                      @keyup="editAnswer(scope.row)" v-model="scope.row.answer">
                  </div>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="满分">
              <template slot-scope="scope">
                <div class="input-font" v-if="isRegion">
                  {{ scope.row.point }}
                </div>
                <div v-else class="answer answer-font">
                  <input type="text" @keydown="wantEdit" :style="!scope.row.point ? 'color: red' : ''"
                    @keyup="editAnswer(scope.row)" v-model="scope.row.point">
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="题类型">
              <template slot-scope="scope">
                <div v-if="isRegion">
                  <span v-if="scope.row.choiceTypeCode == 0">多选题</span>
                  <span v-if="scope.row.choiceTypeCode == 1">单选题</span>
                </div>
                <div v-else>
                  <div class="answer" v-if="scope.row.choiceTypeCode == 0 || scope.row.choiceTypeCode == 1">
                    <el-select v-model="scope.row.choiceTypeCode" placeholder="请选择" size="mini"
                      @change="handleChoiceTypeChange(scope.row)">
                      <el-option v-for="item in choiceTypeList" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div v-if="scope.row.choiceTypeCode == 2">主观题</div>
              </template>
            </el-table-column>

            <el-table-column label="题型设置" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.choiceTypeCode == 0">
                  <div style="cursor: pointer;color: #2877FF;" v-if="scope.row.multiChooseScoringPolicy"
                    @click="handleSetCombination(scope.row)">
                    已设置
                  </div>
                  <el-tooltip :disabled="scope.row.answer !== '' && scope.row.point !== ''"
                    popper-class="objective-popper" v-else content="请先设置答案与满分" placement="top" effect="light">
                    <span style="width: 20%;cursor: pointer;color: #FF5356;" @click="handleSetCombination(scope.row)">
                      未设置
                    </span>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="answer-count">
          <span>总计：</span>
          <span>{{ answerList.length }} 题</span>
          <span style="margin-left: 10px;">总分：</span>
          <label>{{ scoreCount }}分</label>
        </div>
        <div class="set-button" v-if="!isRegion && !ifHistoryData">
          <el-button v-if="answerSubmitCount == 0" type="primary" round :loading="submitAnswerLoading"
            @click="_submitAnswer()">确认标准答案</el-button>
          <el-button v-else type="warning" round :loading="submitAnswerLoading"
            @click="_submitAnswer()">有题目满分为0，是否确认提交？</el-button>
        </div>
      </div>

      <!--多选得分设置弹窗-->
      <yue-dialog :visible.sync="combinationVisible" custom-class="combination-dialog" width="500px"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <!-- 自定义title -->
        <multiple-score-title slot="title" />
        <multiple-score-setting v-if="combinationVisible" :combine="editQuestion" @close="handleCloseCombination" />
      </yue-dialog>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listOnlineStand, updateOnlineStand, getExam } from '@/api/exam/exam'
import exam_enum from '@/utils/exam_enum'
import MultipleScoreTitle from '@/v3/modules/exam/components/MultipleScoreTitle'
import MultipleScoreSetting from '@/v3/components/MultipleScoreSetting'

export default {
  components: { MultipleScoreTitle, MultipleScoreSetting },
  data () {
    return {
      ifHistoryData: false,
      isRegion: false, // 是否是区域统考
      importType: 0,  // 是否为导入考试
      resetAnswerLoading: false,
      schoolId: '',
      loading: false,
      answerSubmitCount: 0,
      examId: this.$route.query.id,
      submitAnswerLoading: false, // 确认标准答案按钮
      answerList: [],
      answerImg: [],
      status: '',
      answerImgUrl: '',
      image: '',
      canEdit: false,
      scoreCount: '--',
      setScore: '',
      setFrom: '',
      setTo: '',
      exam: '',
      isMul: 1, // 1单选 0多选
      halfPoint: '', // 多选题未选全得分

      // 题类型
      choiceTypeList: [
        {
          value: 1,
          label: '单选题'
        }, {
          value: 0,
          label: '多选题'
        }
      ],
      combinationVisible: false,
      editQuestion: {},
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    }),
  },

  created () {
    this.ifHistoryData = sessionStorage.getItem('history') == 1 ? true : false
    this.schoolId = this.userInfo.schoolId
    this._getAnswer()
  },
  methods: {
    async _getExam () {
      let resp = await getExam(this.examId)

      if (resp.success) {
        const exam = resp.body
        this.importType = exam.importType
        if (exam.isMore === 2) {
          this.isRegion = true
        }
      }
    },

    async _getAnswer () {
      this.loading = true
      let resp = await listOnlineStand({
        examId: this.examId
      })
      this.loading = false
      if (resp.success && resp.body) {
        this.answerList = resp.body
        this._sumScore()
        this.$previewRefresh()
      }
    },


    // 手动处理
    async _resetAnswer () {
      this.resetAnswerLoading = true
      let params = {
        examId: this.examId,
      }

      let resp = await getStandAnswerUrl(params)
      this.resetAnswerLoading = false

      if (resp.code === 200 && resp.result) {

        this._getAnswer() // 重新获取标准答案

        this.answerImgUrl = resp.result.ossUrl;
        this.$previewRefresh()

        // 重置标准答案，所有答案、满分都为空
        for (let item of this.answerList) {
          item.point = 0
          item.answer = ''
          item.halfPoint = 0
        }
      } else {
        this.$message.warning('暂无标准答案卷!')
      }
    },

    //提交修改后的标准答案
    async _submitAnswer () {
      if (this.submitAnswerLoading) return

      for (let item of this.answerList) {
        item.choiceType = exam_enum.getKeyByValue(item.choiceTypeCode, "questionType")
        if (item.point == '') {
          item.point = 0
        }

        // 题目得分不能小于0
        if (parseFloat(item.point) < 0) {
          this.$message.warning('题目得分不能小于0')
          return
        }

        // 多选题
        if (item.choiceTypeCode == 0) {
          if (item.halfPoint == null || parseFloat(item.halfPoint) < 0) {
            this.$message.warning('多选题选不全得分不能小于0')
            return
          }
          if (parseFloat(item.halfPoint) > parseFloat(item.point)) {
            this.$message.warning('多选题选不全得分不能大于满分')
            return
          }
        }

        if (item.point === 0 || ((item.choiceTypeCode == 0 || item.choiceTypeCode == 1) && (item.answer == '' || !item.answer))) {
          if (this.answerSubmitCount == 0) {
            this.$message.warning(`有答案选项或者分数为空! 是否继续？`)
            this.answerSubmitCount++
            return
          }

          break
        }
      }


      this.$confirm('请确定题目分数和类型都设置正确?', '提示', { type: 'warning' }).then(() => {
        let params = {
          examId: this.examId,
          standVos: this.answerList
        }

        this.submitAnswerLoading = true
        updateOnlineStand(params).then((resp) => {
          if (resp.success) {
            this.$message.success('确认标准答案成功，即将返回!')

            setTimeout(_ => {
              this.$router.back()
            }, 1200)
          } else {
            this.submitAnswerLoading = false

            this.$message.warning('保存失败，' + resp.message)
          }
        })

      }).catch(() => {

      })
    },

    wantEdit () {
      if (!this.canEdit) {
        this.$confirm('修改标准答案影响很大, 是否继续?', '提示', {
          type: 'warning'
        }).then(() => {
          this.canEdit = true
          this._sumScore()
        }).catch(() => {
          this._sumScore()
        })
      }
    },

    editAnswer (row) {
      if (this.canEdit) {
        this._sumScore();
      }
      row.halfPoint = "";
      row.halfChoiceParams = []
      row.multiChooseScoringPolicy = ''
    },

    //计算总分
    _sumScore () {
      let list = this.answerList
      let sum = 0
      list.map((item) => {
        var number = parseFloat(item.point)
        if (!isNaN(number)) {
          sum += parseFloat(number)
        }
      })
      this.scoreCount = sum
    },

    // 批量修改客观题数据
    totalOn () {
      if (!this.setScore || isNaN(this.setScore)) {
        this.$message.warning('分数输入有误!')
        return false
      }
      if (!this.setFrom || !this.setTo || isNaN(this.setFrom) || isNaN(this.setTo)) {
        this.$message.warning('题号输入有误!')
        return false
      }
      if (parseInt(this.setFrom) > parseInt(this.setTo)) {
        this.$message.warning('题号范围输入有误!')
        return false
      }
      if (this.isMul == 0) {
        if (!this.halfPoint || isNaN(this.halfPoint)) {
          this.$message.warning('选不全分数输入有误!')
          return false
        }
      }

      for (let item of this.answerList) {
        if (item.num >= parseInt(this.setFrom) && item.num <= parseInt(this.setTo) && item.choiceTypeCode != 2) {
          item.point = parseFloat(this.setScore)

          if (this.isMul == 0) {
            if (item.point >= this.halfPoint) {
              item.halfPoint = parseFloat(this.halfPoint);
              item.choiceTypeCode = 0
            } else {
              this.$message.warning('选不全分数不能大于满分!')
            }

          } else {
            item.choiceTypeCode = 1
          }
        }
      }

      this._sumScore()
    },
    handleChoiceTypeChange (row) {
      row.answer = ''
      row.halfPoint = "";
      row.halfChoiceParams = []
      row.multiChooseScoringPolicy = ''
    },
    // 打开组合设置弹框
    handleSetCombination (row) {
      if (row.answer !== '' && row.point !== '') {
        this.editQuestion = row;
        this.combinationVisible = true;
      }
    },
    handleCloseCombination (data) {
      // halfPoint :选不全得分 halfChoiceParams：组合得分
      // 句读题及选项得分需设置
      if (!!data) {
        this.editQuestion.multiChooseScoringPolicy = data.type
        if (data.type !== 'NORMAL_SCORING') {
          if (data.type === 'PARTIAL_CREDIT_SCORING') {
            this.editQuestion.halfPoint = data.params.score
          } else if (data.type === 'OPTION_COMBINATION_SCORING') {
            this.editQuestion.halfChoiceParams = data.params.halfChoiceParams;
          } else {
            let scoringMultiChoiceParam = { scorePerCorrectOption: data.params.score, }
            if (data.params.count) {
              scoringMultiChoiceParam.deadlineOptionCount = data.params.count
            }
            this.editQuestion.scoringMultiChoiceParam = scoringMultiChoiceParam
          }
        }
      }
      this.combinationVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.answer-box {
  .answer-content {
    display: flex;
    margin-bottom: 20px;

    .answer-right {
      flex: 1;
      background: #FFFFFF;
      padding: 15px 10px;
      border-radius: 4px;
      box-sizing: border-box;
    }

    .content-area {
      margin-top: 30px;

      img {
        width: 100%;
      }
    }

    .sub-header {
      position: relative;

      img {
        width: 6px;
        height: 25px;
        position: absolute;
        top: -4px;
      }

      .text {
        color: $color-light;
        margin-left: 15px;
      }
    }

    .no-answer-img {
      padding: 0 50px;
      height: 500px;
      display: flex;
      align-items: center;

      img {
        margin-right: 35px;
        width: 150px;
      }

      label {
        font-size: 22px;
        color: $color-theme;
      }

      p {
        font-size: 14px;
        margin: 10px 0;
        line-height: 22px;
        color: #999999;
      }
    }
  }

  .answer {
    input {
      width: 100%;
      height: 25px;
      outline: none;
    }
  }
}

.allScore {
  height: 35px;
  margin: 15px 0 5px;
  font-size: 12px;

  label {
    color: #999;
  }

  span {
    color: #999;
  }

  .numFrom {
    width: 100px;
    height: 22px;
  }

  .numTo {
    width: 100px;
    height: 22px;
  }

  .numTotal {
    height: 22px;
    float: right;
    line-height: 30px;

    .totalInput {
      width: 40px;
      float: left;
    }
  }

  label {
    margin-top: -2px;
  }

  .scoreInput {
    width: 50%;
  }
}

/*链接到试题列表*/
.paper-list-btn {
  font-size: 14px;
  background-color: #FFFFFF;
  color: #0088CC;
}

.answer-count {
  margin: 15px 0 10px;
  text-align: right;

  span {
    color: #999999;
    font-size: 14px;
  }

  label {
    color: #f88e05;
    font-size: 20px;
  }
}

.set-button {
  margin: 14px 4px 0;
  height: 42px;
  text-align: center;

  .el-button {
    height: 42px;
    font-size: 16px;
  }
}

.input-font {
  font-size: 16px;
  font-weight: bold;
  color: $color-theme;
}

.inputSpace {
  border: 1px solid #f88e05;
}

.inputWraning {
  animation: glow 1.2s infinite;
}

.type-select {
  display: inline-block;
  width: 120px;
}

@keyframes glow {
  0% {
    border-color: #fff;
  }

  100% {
    border-color: #f88e05;
  }
}
</style>

<style lang="scss">
.answer-box {

  .el-table__header-wrapper .el-table .cell,
  .el-table th div {
    padding: 0 !important;
  }

  .el-table th>.cell {
    font-size: 12px;
  }

  .el-table--mini td {
    padding: 3px 0;
  }

  .answer-font {

    .el-input__inner,
    input,
    .span {
      font-size: 16px;
      font-weight: bold;
      color: $color-theme;
    }
  }

}

.el-table th>.cell {
  font-size: 12px;
}

.el-table--mini td {
  padding: 3px 0;
}

.answer-font {

  .el-input__inner,
  input,
  .span {
    font-size: 16px;
    font-weight: bold;
    color: $color-theme;
  }
}
</style>
